import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import SignupConsultPopup from '@/components/header/SignupConsultPopup';
import { PrivacyConsentPopupProvider } from '@/hooks/usePrivacyConsentPopup';

type SignupConsultPopupContextValue = {
	openSignupConsultPopup: () => void;
	closeSignupConsultPopup: () => void;
	isSignupConsultPopupOpen: boolean;
};

const SignupConsultPopupContext = createContext<SignupConsultPopupContextValue | undefined>(undefined);

export function SignupConsultPopupProvider({ children }: { children: ReactNode }) {
	const [isSignupConsultPopupOpen, setIsSignupConsultPopupOpen] = useState(false);

	const value = useMemo(
		() => ({
			openSignupConsultPopup: () => setIsSignupConsultPopupOpen(true),
			closeSignupConsultPopup: () => setIsSignupConsultPopupOpen(false),
			isSignupConsultPopupOpen
		}),
		[isSignupConsultPopupOpen]
	);

	return (
		<SignupConsultPopupContext.Provider value={value}>
			<PrivacyConsentPopupProvider>
				{children}
				{isSignupConsultPopupOpen &&
					createPortal(<SignupConsultPopup onClose={value.closeSignupConsultPopup} />, document.body)}
			</PrivacyConsentPopupProvider>
		</SignupConsultPopupContext.Provider>
	);
}

export function useSignupConsultPopup() {
	const context = useContext(SignupConsultPopupContext);
	if (!context) {
		throw new Error('useSignupConsultPopup must be used within SignupConsultPopupProvider');
	}
	return context;
}
